var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "admin-linear-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function ($event) {
          return _vm.localeForm.errors.clear($event.target.name)
        },
      },
    },
    [
      _c("div", { staticClass: "admin-linear-form__grid" }, [
        _c(
          "div",
          { staticClass: "admin-linear-field" },
          [
            _c("label", [_vm._v(_vm._s(_vm.trans("locale.name")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localeForm.name,
                  expression: "localeForm.name",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                value: "",
                name: "name",
                placeholder: _vm.trans("locale.name"),
              },
              domProps: { value: _vm.localeForm.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.localeForm, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.localeForm, "prop-name": "name" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "admin-linear-field" },
          [
            _c("label", [_vm._v(_vm._s(_vm.trans("locale.locale")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localeForm.locale,
                  expression: "localeForm.locale",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                value: "",
                name: "locale",
                placeholder: _vm.trans("locale.locale"),
              },
              domProps: { value: _vm.localeForm.locale },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.localeForm, "locale", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.localeForm, "prop-name": "locale" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-linear-form__actions" },
        [
          !_vm.id
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm admin-form-btn-cancel",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.trans("general.cancel")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.id,
                  expression: "id",
                },
              ],
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
              attrs: { to: "/configuration/locale" },
            },
            [_vm._v(_vm._s(_vm.trans("general.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
              attrs: { type: "submit" },
            },
            [
              _vm.id
                ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }